module.exports = __webpack_public_path__ + "static/media/wowcard.a17eacba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wowcard.png
// module id = 5999
// module chunks = 1